import dayjs, { type Dayjs } from 'dayjs';
import type { DateRangeValue } from '@/types/antd';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@/std/const/date';

/**
 * Converte segundos em 'minutos:segundos'
 * ex: 60 > "01:00"
 */
export function formatSecondsToMinutes(seconds: number): string {
    const min = Math.floor((seconds / 60) % 60)
        .toString()
        .padStart(2, '0');

    const sec = Math.floor((seconds % 60) % 60)
        .toString()
        .padStart(2, '0');

    return `${min}:${sec}`;
}

/** Retorna a data atual no formato dia/mes/ano */
export function getCurrentDate(): string {
    return dayjs().format(DATE_FORMAT);
}

/** Retorna a data e tempo atual no formato dia/mes/ano hora:minuto:segundo */
export function getCurrentDateTime(): string {
    return dayjs().format(DATE_TIME_FORMAT);
}

/** Retorna o período de um mês até a data atual */
export function getOneMonthPeriod(): Interval<Dayjs> {
    return {
        end: dayjs(),
        start: dayjs().add(-1, 'month'),
    };
}

/** Retorna o período do mês anterior */
export function getPreviousMonth(): Interval<Dayjs> {
    return {
        end: dayjs().subtract(1, 'month').endOf('month'),
        start: dayjs().subtract(1, 'month').startOf('month'),
    };
}

export function getCurrentMonth(): Interval<Dayjs> {
    return {
        end: dayjs().endOf('month'),
        start: dayjs().startOf('month'),
    };
}

/** Retorna o período do próximo mês */
export function getNextMonth(): Interval<Dayjs> {
    return {
        end: dayjs().add(1, 'month').endOf('month'),
        start: dayjs().add(1, 'month').startOf('month'),
    };
}

/** DateRangeValue (antd) -> Interval (std) */
export function rangePickerToInterval(
    value: DateRangeValue | null | undefined,
): Interval<Dayjs> | undefined {
    if (value?.[0] && value[1]) {
        const [start, end] = value;
        return { end, start };
    }

    return undefined;
}

/** Interval (std) -> DateRangeValue (antd) */
export function intervalToRangePicker(
    value: Interval<Dayjs> | null | undefined,
): DateRangeValue | undefined {
    return value ? [value.start, value.end] : undefined;
}

export function intervalDayjsToIntervalString(
    interval: Interval<Dayjs> | null,
    format: string,
): Interval<string> | null {
    if (!interval) {
        return null;
    }

    return {
        end: interval.end.format(format),
        start: interval.start.format(format),
    };
}
